import { Box, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { VerificationTag } from './VerificationTag.component';

export type VerificationInfoLabelProps = {
  label: string;
  verified: boolean;
};

export const VerificationInfoLabel: React.VFC<VerificationInfoLabelProps> = ({ label, verified }) => {
  const { classes } = useEmailStyles();

  return (
    <Box className={classes.root}>
      <Typography style={{ fontWeight: 500 }}>{label}</Typography>
      <VerificationTag verified={verified} />
    </Box>
  );
};

const useEmailStyles = makeStyles({ name: 'Email' })(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gridGap: theme.spacing(2)
  },
}));
